import { GENERATE, MODAL_TYPES } from '@/common/constants';
import Item from '@/containers/ToolPopoverManager/Grid/Item';
import { useModal, useToolBar } from '@/hooks';

export default {
  components: {
    Item
  },
  data() {
    const items = [
      {
        name: 'New Background',
        value: GENERATE.NEW_BACKGROUND
      },
      {
        name: 'New Clipart',
        value: GENERATE.NEW_CLIP_ART
      }
    ];
    return { items };
  },
  setup() {
    const { toggleModal } = useModal();
    const { setToolNameSelected } = useToolBar();

    return {
      toggleModal,
      setToolNameSelected
    };
  },
  methods: {
    onClick(value) {
      this.toggleModal({
        isOpenModal: true,
        modalData: {
          type:
            value === GENERATE.NEW_BACKGROUND
              ? MODAL_TYPES.GENERATE_BACKGROUND
              : MODAL_TYPES.GENERATE_CLIPART
        }
      });
      this.setToolNameSelected({
        name: ''
      });
    }
  }
};
